import React from 'react';
import { ReadyForInspectionIndicator } from '../../job-indicators';

export default function ReadyForInspectionBadge() {
  // We'll reuse the ReadyForInspectionIndicator from job-indicators.js
  return <ReadyForInspectionIndicator />;
} 